import React from 'react';
import { CircularProgress, Stack } from '@mui/material';

export const CalendarSkeleton = () => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <CircularProgress />
    </Stack>
  );
};
